<template>
  <a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
      <div class="row no-gutters">
        <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
          <div class="card-body">
            <!-- <div class="row">
                <div class="col-md-4">
                  <base-input label="Group By">
                    <select
                      class="form-control"
                      size="large"
                      v-model="inputGroupBy"
                      @click.prevent="autoChange"
                    >
                      <option
                        v-for="option in groupOptions"
                        v-bind:value="option.key"
                        v-bind:key="option.key"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </base-input>
                </div>
              </div> -->

            <div v-if="inputGroupBy == 'monthly'" class="row">
              <div class="col-md-4">
                <base-input alternative="" label="From"
                  ><br />
                  <a-month-picker
                    v-model="inputFrom"
                    placeholder="Select month"
                    style="width: 100%"
                    :format="monthFormat"
                  />
                </base-input>
              </div>

              <div class="col-md-4">
                <base-input alternative="" label="To"
                  ><br />
                  <a-month-picker
                    v-model="inputTo"
                    placeholder="Select month"
                    style="width: 100%"
                    :format="monthFormat"
                  />
                </base-input>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-md-4">
                <base-input alternative="" label="From"
                  ><br />
                  <a-range-picker
                    v-model="inputDate"
                    format="MM/DD/YYYY"
                    :placeholder="['Start Date', 'End Date']"
                    style="width: 100%"
                  />
                </base-input>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <base-radio name="All" v-model="inputReportDoc"> All Sales</base-radio>
                <base-radio name="MMS" v-model="inputReportDoc"> MMS Sales </base-radio>
                <base-radio name="POS" v-model="inputReportDoc"> POS Sales </base-radio>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <base-input alternative="" label="Select Sales Channel">
                  <a-select
                    mode="multiple"
                    v-model="inputSalesChannel"
                    showSearch
                    placeholder="All Sales Channel"
                    optionFilterProp="children"
                    style="width: 100%"
                    :filterOption="filterOption"
                  >
                    <a-select-option
                      v-for="option in salesChannelOptions"
                      :key="option.id"
                      :value="option.id"
                      >{{ option.name }}</a-select-option
                    >
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <base-input label="Sort By">
                  <select
                    class="form-control"
                    size="large"
                    v-model="inputSortBy"
                    @click.prevent="sortChange"
                  >
                    >
                    <option
                      v-for="option in sortOptions"
                      v-bind:value="option.key"
                      v-bind:key="option.key"
                    >
                      {{ option.value }}
                    </option>
                  </select>
                </base-input>
              </div>
              <div class="col-md-2 mt-3 pt-3">
                <button
                  type="button"
                  class="btn btn-sm btn-link"
                  @click="showSortInfoDiv"
                >
                  {{ showSortInfo == "asc" ? "Ascending (A-Z) ↡" : "Descending (Z-A) ↟" }}
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <base-input
                  type="number"
                  min="0"
                  v-if="inputSortBy == 'total_amount' || inputSortBy == 'qty'"
                  placeholder="Enter Points"
                  label="Show Top"
                  v-model="inputShowTop"
                />
                <base-input
                  type="number"
                  min="0"
                  v-else
                  placeholder="Enter Points"
                  label="Show Top"
                  v-model="inputShowTop"
                  disabled
                />
              </div>
            </div>

            <base-checkbox
              class="mb-3"
              v-model="isShowDetail"
              :disabled="inputGroupBy == ''"
            >
              Show Details
            </base-checkbox>
            <!-- <base-checkbox class="mb-3" v-model="isSeparateSite">
                Separate per site
              </base-checkbox> -->

            <!-- <div class="row">
              <div class="col-md-4">
                <button
                  class="btn btn-sm"
                  style="background-color: #394a5d; color: white"
                  @click.prevent="advanceFilter(true)"
                >
                  {{ toggleLabel }}
                </button>
              </div>
            </div> -->

            <div class="row">
              <div class="col-md-12">
                <br />
                <!-- <button
                    class="btn btn-sm btn-default float-right"
                    style="border-radius: 24px; border: 0px; width: 20%"
                    @click.prevent="generateReport"
                  >
                    Generate Report in PDF
                  </button>
                  &nbsp; &nbsp; -->
                <button
                  v-if="JsonData.length < 1"
                  class="btn btn-sm btn-default float-right"
                  style="border-radius: 24px; border: 0px; width: 20%"
                  @click.prevent="generateFile"
                >
                  Generate Report
                </button>
                &nbsp; &nbsp;
                <vue-json-to-csv
                  v-if="JsonData.length > 0"
                  :json-data="JsonData"
                  :csv-title="
                    currentProfile.replace(/_/g, '-') + '-' + currDate.replace(/ /g, '_')
                  "
                >
                  <button
                    id="clickCsvExport"
                    class="btn btn-sm btn-success float-right"
                    style="border-radius: 24px; border: 0px; width: 20%"
                  >
                    Download CSV
                  </button>
                  &nbsp; &nbsp;
                </vue-json-to-csv>
                <download-excel
                  v-if="JsonData.length > 0"
                  :data="JsonData"
                  :name="
                    currentProfile.replace(/_/g, '-') +
                    '-' +
                    currDate.replace(/ /g, '')
                  "
                  type="xlsx"
                  class="float-right"
                  style="width: 20%"
                >
                  <button
                    class="btn btn-sm btn-success"
                    style="border-radius: 24px; border: 0px; width: 100%"
                    @click.prevent="clearJsonData"
                  >
                    Download excel
                  </button>
                  &nbsp; &nbsp;
                </download-excel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
        <a-drawer
          title=""
          width="500"
          placement="right"
          @close="closeFilter"
          :visible="advancedFilterVisible"
        >
          <advance-filter
            :parentParams="advancedFilterParams"
            @changeParams="changeParams"
            @closeFilter="closeFilter"
          ></advance-filter>
        </a-drawer>
      </div>
    </div>
  </a-spin>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from "../../controllers/secureStorage";
import AdvanceFilter from "../Bir Reports/ReportAdvanceFilter";
import reportUtils from "../../components/reportUtils";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import VueJsonToCsv from "vue-json-to-csv";

import { mapState, mapActions } from "vuex";

var component_x;

export default {
  components: {
    AdvanceFilter,
    VueJsonToCsv,
  },
  data() {
    return {
      spinning: false,
      inputDate: [moment().startOf("day"), moment().endOf("day")],
      inputGroupBy: "",
      // groupOptions: [
      //   { key: "", value: "No Grouping" },
      //   { key: "supplier_id", value: "Supplier" },
      //   { key: "sales_channel_id", value: "Sales Channel" },
      //   { key: "supplier_type_id", value: "Supplier Type, Supplier" },
      //   { key: "brand_id", value: "Brand" },
      //   { key: "division_id", value: "Division" },
      //   { key: "department_id", value: "Department" },
      //   { key: "section_id", value: "Section" },
      //   { key: "category_id", value: "Category" },
      //   { key: "customer_id", value: "Customer" },
      //   { key: "customer_type_id", value: "Customer Type" },
      //   { key: "daily", value: "Daily Sales" },
      //   { key: "monthly", value: "Monthly Sales" },
      //   { key: "salesman_id", value: "Salesman" },
      // ],
      inputSite: [],
      inputSalesChannel: [],
      site_type: "ho",
      siteOptions: [],
      salesChannelOptions: [],
      inputSortBy: "id",
      sortOptions: [
        { key: "id", value: "Product Code" },
        { key: "barcode", value: "Barcode" },
        { key: "name", value: "Name or Description" },
        { key: "total_amount", value: "Total Amount" },
        { key: "qty", value: "Total Quantity" },
      ],
      isSeparateSite: true,
      isShowDetail: true,
      inputReportDoc: "MMS",
      inputFrom: moment().startOf("month"),
      inputTo: moment().endOf("month"),
      inputCutoff: moment().startOf("day"),
      monthFormat: "MM/YYYY",
      birSalesReports: [],

      toggleAdvanceFilter: false,
      toggleLabel: "Advanced Filter",
      advancedFilterParams: {},
      params: {},
      advancedFilterVisible: true,

      currDate: moment().format("L_LT").split(":").join(";"),
      showSortInfo: "asc",
      inputShowTop: 0,
      JsonData: [],
      accessRights:[],
      accessCostPriceRights:[]
    };
  },
  mounted: async function () {
    component_x = this;

    var sales_channels = await HTTPRequest.getRequest(
      component_x.endPoint + "sales_channels?status=A",
      null
    );

    component_x.salesChannelOptions = sales_channels["data"];
    component_x.sort(component_x.salesChannelOptions);

    let siteId = secureStorage.getItem("defaultSiteId");
    this.inputSite = [siteId];

    let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null);
    if (site != undefined) {
      this.site_type = site.site_type;
    }

    if (component_x.categoriesOptions.length == 0) {
      var options = await HTTPRequest.getRequest(
        this.endPoint + "categories/cascader_view",
        null
      );
      component_x.updateCategoriesOptions(options);
    }
    this.accessRights = this.$attrs.access_rights || []
    var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
    if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
        this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
    }else {
        this.accessCostPriceRights = []
    }
  },
  computed: {
    ...mapState(["currentProfile", "endPoint", "categoriesOptions"]),
  },
  methods: {
    ...mapActions(["updateCategoriesOptions"]),
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Advanced Info
    showSortInfoDiv() {
      this.showSortInfo == "asc"
        ? (this.showSortInfo = "desc")
        : (this.showSortInfo = "asc");
    },
    autoChange(e) {
      if (e.target.value == "") {
        this.isShowDetail = true;
      }
    },
    sortChange(e) {
      if (e.target.value != "total_amount" || e.target.value != "qty") {
        this.inputShowTop = 0;
      }
    },
    sort(data) {
      data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    convertToCurrency(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    advanceFilter(value) {
      this.toggleAdvanceFilter = value;
      if (this.toggleAdvanceFilter == true) {
        this.toggleLabel = "Collapse Filter";
      } else {
        this.toggleLabel = "Advanced Filter";
      }
    },
    closeFilter() {
      this.advanceFilter(false);
    },
    changeParams(params, actualParams, mode) {
      this.params = params;
      this.advancedFilterParams = actualParams;

      if (mode == "filter") {
        this.advanceFilter(false);
      }
    },

    generateReport: async function () {
      this.spinning = true;
      let { from_date, to_date, from_header, to_header } = reportUtils.buildFromToHeaders(
        component_x,
        this.inputGroupBy,
        this.inputDate
      );
      let {
        filter_header,
        additional_params,
        status_header,
      } = reportUtils.advanceFilterTools.buildAdditionalParams(
        this.params,
        this.advancedFilterParams,
        null
      );

      let parameters = {
        site_id: this.inputSite.toString(),
        sales_channel_id: this.inputSalesChannel.toString(),
        report_document: this.inputReportDoc,
        date_from: from_date,
        date_to: to_date,
        group: this.inputGroupBy,
        isShow: this.isShowDetail,
        order: this.inputSortBy,
        by: this.showSortInfo,
        top: this.inputShowTop,
        isSeparate: this.isSeparateSite,
        advanced_filter: this.params,
      };

      var get_request = await HTTPRequest.getRequest(
        this.endPoint + "ecomm_daily_sales?" + parameters
      );
      if (get_request.error) {
        reportUtils.openNotificationWithIcon(component_x, "error", get_request.error);
        return;
      }
      var siteSpecific = get_request;
      if (siteSpecific.length > 0) {
        var doc = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "legal",
        });

        // let reportLogo = document.getElementById("reportLogo");
        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

        let headers = [];
        if (this.isShowDetail == true) {
          headers = [
            [
              { content: "#", styles: { halign: "center", valign: "center" } },
              {
                content: "Prod. Code",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Barcode",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Description",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Retail Price",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Qty",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Avg Price",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Landed Cost",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Avg Cost",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Total Amount",
                styles: { halign: "center", valign: "center" },
              },
            ],
          ];
        } else {
          headers = [
            [
              "",
              {
                content: "Qty",
                styles: { halign: "center", valign: "center" },
              },
              {
                content: "Total Amount",
                styles: { halign: "center", valign: "center" },
              },
            ],
          ];
        }

        for (let x = 0; x < siteSpecific.length; x++) {
          this.birSalesReports = siteSpecific[x].report_details;

          let total_qty = 0;
          let total_total_amount = 0;
          let grand_qty = 0;
          let grand_total_amount = 0;

          if (x > 0 && this.birSalesReports.length > 0) {
            doc.addPage();
          }

          let reportData = [];
          let grouper = "start";
          let type_header = "start";

          if (this.birSalesReports.length > 0) {
            let monthly_grouper_arr = [];
            let arr = "start";

            if (this.inputGroupBy == "monthly" && this.isShowDetail == true) {
              for (let i = 0; i < this.birSalesReports.length; i++) {
                let reportLine = this.birSalesReports[i];

                if (i == this.birSalesReports.length - 1) {
                  if (arr == "start") {
                    monthly_grouper_arr.push({
                      key: reportLine.grouper_id,
                      value: reportLine.grouper_name,
                    });
                  } else {
                    if (arr.key == reportLine.grouper_id) {
                      //replace value then push
                      if (arr.value > reportLine.grouper_name) {
                        arr.value = reportLine.grouper_name;
                      }

                      monthly_grouper_arr.push(arr);
                    } else {
                      //push prev arr
                      monthly_grouper_arr.push(arr);

                      //push current arr
                      monthly_grouper_arr.push({
                        key: reportLine.grouper_id,
                        value: reportLine.grouper_name,
                      });
                    }
                  }
                } else {
                  if (arr == "start") {
                    arr = {
                      key: reportLine.grouper_id,
                      value: reportLine.grouper_name,
                    };
                  } else {
                    if (arr.key == reportLine.grouper_id) {
                      //replace value
                      if (arr.value > reportLine.grouper_name) {
                        arr.value = reportLine.grouper_name;
                      }
                    } else {
                      //push prev arr
                      monthly_grouper_arr.push(arr);

                      //replace current arr
                      arr = {
                        key: reportLine.grouper_id,
                        value: reportLine.grouper_name,
                      };
                    }
                  }
                }
              }
            }

            for (let i = 0; i < this.birSalesReports.length; i++) {
              let reportLine = this.birSalesReports[i];

              let grouper_name = reportLine.grouper_name;
              if (this.inputGroupBy == "daily") {
                grouper_name = moment(reportLine.grouper_name).format("YYYY/MM/DD");
              } else if (this.inputGroupBy == "monthly") {
                let vdate = monthly_grouper_arr.find(
                  (x) => x.key === reportLine.grouper_id
                ).value;
                grouper_name = moment(vdate).format("(YYYY) DD - MMMM");
              }

              if (this.inputGroupBy == "supplier_type_id") {
                if (type_header == "start") {
                  let type_header = [
                    {
                      content: reportLine.header_name,
                      colSpan: 3,
                      styles: { halign: "left", fontStyle: "bold" },
                    },
                  ];
                  reportData.push(Object.assign({}, type_header));
                } else {
                  if (type_header != reportLine.header_id) {
                    let type_header = [
                      {
                        content: reportLine.header_name,
                        colSpan: 3,
                        styles: { halign: "left", fontStyle: "bold" },
                      },
                    ];
                    reportData.push(Object.assign({}, type_header));
                  }
                }
                type_header = reportLine.header_id;
              }

              if (this.inputGroupBy != "") {
                if (this.isShowDetail == true) {
                  if (grouper == "start") {
                    let detail_header = [
                      {
                        content: grouper_name,
                        colSpan: 3,
                        styles: { halign: "left", fontStyle: "bold" },
                      },
                    ];
                    reportData.push(Object.assign({}, detail_header));
                  } else {
                    if (grouper != reportLine.grouper_id) {
                      let detail_header = [
                        {
                          content: grouper_name,
                          colSpan: 3,
                          styles: { halign: "left", fontStyle: "bold" },
                        },
                      ];
                      reportData.push(Object.assign({}, detail_header));
                    }
                  }
                  grouper = reportLine.grouper_id;
                }
              }

              let detail = [];
              if (this.isShowDetail == true) {
                detail = [
                  i + 1,
                  reportLine.product_code,
                  reportLine.barcode,
                  reportLine.description,
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.retail_price)), 'Y'),
                  this.convertToCurrency(Number(reportLine.qty)),
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_price)), 'Y'),
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.landed_cost)), 'Z'),
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_cost)), 'Z'),
                  this.convertToCurrency(Number(reportLine.total_amount)),
                ];
              } else {
                detail = [
                  grouper_name,
                  this.convertToCurrency(Number(reportLine.qty)),
                  this.convertToCurrency(Number(reportLine.total_amount)),
                ];
              }

              reportData.push(Object.assign({}, detail));

              total_qty += Number(reportLine.qty);
              total_total_amount += Number(reportLine.total_amount);

              grand_qty += Number(reportLine.qty);
              grand_total_amount += Number(reportLine.total_amount);

              if (i == this.birSalesReports.length - 1) {
                if (this.inputGroupBy != "") {
                  let sub_detail = [];
                  if (this.isShowDetail == true) {
                    let spacer = grouper_name;
                    if (this.inputGroupBy == "supplier_type_id") {
                      spacer = reportLine.header_name;
                    }

                    sub_detail = [
                      "",
                      "",
                      "",
                      {
                        content: spacer,
                        styles: { halign: "right", fontStyle: "bold" },
                      },
                      "",
                      this.convertToCurrency(total_qty),
                      "",
                      this.convertToCurrency(total_total_amount),
                    ];
                    reportData.push(Object.assign({}, ["rowLine"]));
                    reportData.push(Object.assign({}, sub_detail));
                  }
                }

                reportData.push(Object.assign({}, ["rowLine"]));

                if (this.isShowDetail == true) {
                  reportData.push(
                    Object.assign({}, [
                      "",
                      "",
                      "",
                      "Grand Total :",
                      this.convertToCurrency(grand_qty),
                      "",
                      this.convertToCurrency(grand_total_amount),
                    ])
                  );
                } else {
                  reportData.push(
                    Object.assign({}, [
                      "Grand Total :",
                      this.convertToCurrency(grand_qty),
                      this.convertToCurrency(grand_total_amount),
                    ])
                  );
                }
              } else {
                if (this.isShowDetail == true) {
                  let current_grouper = "";
                  let next_grouper = "";
                  if (this.inputGroupBy == "supplier_type_id") {
                    current_grouper = reportLine.header_id;
                    next_grouper = this.birSalesReports[i + 1].header_id;
                  } else {
                    current_grouper = reportLine.grouper_id;
                    next_grouper = this.birSalesReports[i + 1].grouper_id;
                  }

                  if (current_grouper != next_grouper) {
                    if (this.inputGroupBy != "") {
                      reportData.push(Object.assign({}, ["rowLine"]));
                      let sub_detail = [];

                      let spacer = grouper_name;
                      if (this.inputGroupBy == "supplier_type_id") {
                        spacer = reportLine.header_name;
                      }

                      if (this.isShowDetail == true) {
                        sub_detail = [
                          "",
                          "",
                          "",
                          {
                            content: spacer,
                            styles: { halign: "right", fontStyle: "bold" },
                          },
                          "",
                          this.convertToCurrency(total_qty),
                          "",
                          this.convertToCurrency(total_total_amount),
                        ];
                      } else {
                        sub_detail = [
                          {
                            content: spacer,
                            styles: { halign: "right", fontStyle: "bold" },
                          },
                          this.convertToCurrency(total_qty),
                          this.convertToCurrency(total_total_amount),
                        ];
                      }
                      reportData.push(Object.assign({}, sub_detail));

                      total_qty = 0;
                      total_total_amount = 0;
                    }
                  }
                }
              }
            }
          }

          let group_text = "";
          if (this.inputGroupBy != "") {
            group_text =
              " by " + this.groupOptions.find((x) => x.key === this.inputGroupBy).value;
          }

          doc.setFontSize(14);
          doc.setFontType("bold");
          doc.text(15, 20, "Daily Sales Report" + group_text);
          doc.setFontType("normal");
          doc.setFontSize(10);
          if (this.isSeparateSite == true) {
            doc.text(340, 20, siteSpecific[x].report_details[0].site_name, "right");
          } else {
            let site_text = "";
            if (this.inputSite.length == 0) {
              site_text = "All Sites";
            } else {
              let sites = this.inputSite;
              for (var s = 0; s < sites.length; s++) {
                if (s == 0) {
                  site_text += this.siteOptions.find((x) => x.id === sites[s]).name;
                } else {
                  site_text +=
                    ", " + this.siteOptions.find((x) => x.id === sites[s]).name;
                }
              }
            }
            doc.text(340, 20, site_text, "right");
          }
          doc.text(15, 25, "For the Period of " + from_header + " to " + to_header);

          let splitTitle = doc.splitTextToSize(
            "Filtered by: " + status_header + filter_header,
            180
          );
          doc.text(15, 30, splitTitle);

          let colStyles = {};

          if (this.isShowDetail == true) {
            colStyles = {
              0: { cellWidth: 10 },
              1: { cellWidth: 35 },
              2: { cellWidth: 30 },
              3: { cellWidth: 70 },
              4: { cellWidth: 30 },
              5: { cellWidth: 30 },
              6: { cellWidth: 30 },
              7: { cellWidth: 30 },
              8: { cellWidth: 30 },
              9: { cellWidth: 30 },
            };
          } else {
            colStyles = {
              0: { cellWidth: 205 },
              1: { cellWidth: 60 },
              2: { cellWidth: 60 },
            };
          }

          doc.autoTable({
            startY: 45,
            head: headers,
            body: reportData,
            theme: "plain",
            tableWidth: "wrap",
            headStyles: {
              lineWidth: 0.15,
              cellPadding: 2,
            },
            styles: {
              cellPadding: 1.0,
              fontSize: 10,
              halign: "right",
            },
            columnStyles: colStyles,
            didParseCell: function (data) {
              if (data.row.section == "body" && data.row.raw[0] == "rowLine") {
                data.cell.styles.fillColor = [0, 0, 0];
                data.cell.styles.fontSize = 1;
                data.cell.styles.cellPadding = 0;
              } else if (
                data.row.section == "body" &&
                (data.row.raw[0] == "Grand Total :" || data.row.raw[3] == "Grand Total :")
              ) {
                data.cell.styles.fontStyle = "bold";
              }
            },
          });

          let printed_by = secureStorage.getItem("email");
          if (printed_by == null) {
            printed_by = "";
          }
          reportUtils.pdfTools.addFooter(
            doc,
            printed_by,
            "Daily Sales Report" + group_text,
            340,
            200,
            x + 1,
            siteSpecific.length
          );
        }

        window.open(URL.createObjectURL(doc.output("blob")));
        // doc.save(`Daily_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
      } else {
        reportUtils.openNotificationWithIcon(
          component_x,
          "error",
          "Please make sure to check your current filters."
        );
      }
      this.spinning = false;
    },
    generateFile: async function () {
      this.spinning = true;
      let from_date = "";
      let to_date = "";

      let from_header = "";
      let to_header = "";

      if (this.inputGroupBy != "monthly") {
        if (this.inputDate.length == 0) {
          reportUtils.openNotificationWithIcon(
            component_x,
            "error",
            "Please make sure to check your current filters."
          );
          return;
        }

        from_date = this.inputDate[0].format("YYYY-MM-DD HH:mm:ss");
        to_date = this.inputDate[1].format("YYYY-MM-DD HH:mm:ss");

        from_header = this.inputDate[0].format("MMMM DD, YYYY");
        to_header = this.inputDate[1].format("MMMM DD, YYYY");
      } else {
        if (this.inputFrom == null || this.inputTo == null) {
          reportUtils.openNotificationWithIcon(
            component_x,
            "error",
            "Please make sure to check your current filters."
          );
          return;
        }

        from_date = this.inputFrom.format("YYYY-MM-DD HH:mm:ss");
        to_date = this.inputTo.format("YYYY-MM-DD HH:mm:ss");

        from_header = this.inputFrom.format("MMMM DD, YYYY");
        to_header = this.inputTo.format("MMMM DD, YYYY");
      }

      var filter_header = "";
      var additional_params = "";

      var status_header = "([Active],[Inactive],[Phase-out])";
      if (this.params.status != undefined && this.params.status.length != 0) {
        var statuses = this.params.status;
        for (let s = 0; s < statuses.length; s++) {
          const element = statuses[s];
          let text;
          switch (element) {
            case "A":
              text = "Active";
              break;
            case "I":
              text = "Inactive";
              break;
            case "P":
              text = "Phase-out";
              break;
          }
          if (s == 0) {
            status_header = "(";
            status_header += `[${text}]`;
          } else {
            status_header += `,[${text}]`;
            if (s == statuses.length - 1) {
              status_header = ")";
            }
          }
        }
        additional_params += "&status=" + this.params.status;
      }

      if (
        this.params.design_id != undefined &&
        this.params.design_id != null &&
        this.params.design_id.length != 0
      ) {
        additional_params += "&design_id=" + this.params.design_id;
        filter_header += ` with Design (${this.filterParams.design_name})`;
      }

      if (
        this.params.color_id != undefined &&
        this.params.color_id != null &&
        this.params.color_id.length != 0
      ) {
        additional_params += "&color_id=" + this.params.color_id;
        filter_header += ` with Color (${this.filterParams.color_name})`;
      }

      if (
        this.params.size_id != undefined &&
        this.params.size_id != null &&
        this.params.size_id.length != 0
      ) {
        additional_params += "&size_id=" + this.params.size_id;
        filter_header += ` with Size (${this.filterParams.size_name})`;
      }

      if (
        this.params.product_line_id != undefined &&
        this.params.product_line_id != null &&
        this.params.product_line_id.length != 0
      ) {
        additional_params += "&product_line_id=" + this.params.product_line_id;
        filter_header += ` with Product Line (${this.filterParams.product_line_name})`;
      }

      if (
        this.params.product_type != undefined &&
        this.params.product_type != null &&
        this.params.product_type.length != 0
      ) {
        additional_params += "&product_type=" + this.params.product_type;
        filter_header += ` with Product Type (${this.filterParams.product_type_name})`;
      }

      if (
        this.params.supplier_type_id != undefined &&
        this.params.supplier_type_id != null &&
        this.params.supplier_type_id.length != 0
      ) {
        additional_params += "&supplier_type_id=" + this.params.supplier_type_id;
        filter_header += ` with Supplier Type (${this.filterParams.supplier_type_name})`;
      }

      if (
        this.params.tax_type != undefined &&
        this.params.tax_type != null &&
        this.params.tax_type.length != 0
      ) {
        additional_params += "&tax_type=" + this.params.tax_type;
        filter_header += ` with Tax Type (${this.filterParams.tax_type_name})`;
      }

      if (
        this.params.barcode != undefined &&
        this.params.barcode != null &&
        this.params.barcode != ""
      ) {
        additional_params += "&barcode=" + this.params.barcode;
        filter_header += ` with Barcode (${this.params.barcode})`;
      }

      if (
        this.params.stock_no != undefined &&
        this.params.stock_no != null &&
        this.params.stock_no != ""
      ) {
        additional_params += "&stock_no=" + this.params.stock_no;
        filter_header += ` with Stock No. (${this.params.stock_no})`;
      }

      if (
        this.params.name != undefined &&
        this.params.name != null &&
        this.params.name != ""
      ) {
        additional_params += "&name=" + this.params.name;
        filter_header += ` with Name (${this.params.name})`;
      }

      if (
        this.params.retail_price != undefined &&
        this.params.retail_price != null &&
        this.params.retail_price != ""
      ) {
        additional_params += "&retail_price=" + this.params.retail_price;
        filter_header += ` with Retail Price (${this.params.retail_price})`;
      }

      if (this.params.category_id != undefined && this.params.category_id.length != 0) {
        additional_params += "&category_id=" + this.params.category_id;
        if (this.params.category_name != undefined) {
          filter_header += ` with Category (${this.filterParams.category_name})`;
        }
      }

      if (this.params.division_id != undefined && this.params.division_id.length != 0) {
        additional_params += "&division_id=" + this.params.division_id;
        if (this.params.division_name != undefined) {
          filter_header += ` with Division (${this.filterParams.division_name})`;
        }
      }

      if (
        this.params.department_id != undefined &&
        this.params.department_id.length != 0
      ) {
        additional_params += "&department_id=" + this.params.department_id;
        if (this.params.department_name != undefined) {
          filter_header += ` with Department (${this.filterParams.department_name})`;
        }
      }

      if (this.params.section_id != undefined && this.params.section_id.length != 0) {
        additional_params += "&section_id=" + this.params.section_id;
        if (this.params.section_name != undefined) {
          filter_header += ` with Section (${this.filterParams.section_name})`;
        }
      }

      if (this.params.supplier_id != undefined && this.params.supplier_id.length != 0) {
        additional_params += "&supplier_id=" + this.params.supplier_id;
        filter_header += ` with Supplier (${this.filterParams.supplier_name})`;
      } else {
        filter_header += ` with Supplier ([All Suppliers])`;
      }

      if (this.params.brand_id != undefined && this.params.brand_id.length != 0) {
        additional_params += "&brand_id=" + this.params.brand_id;
        filter_header += ` with Brand (${this.filterParams.brand_name})`;
      }

      let cutoff = "00:00";
      if (this.inputCutoff != null) {
        cutoff = this.inputCutoff.format("HH:mm");
      }

      var get_request = await HTTPRequest.getRequest(
        this.endPoint +
          "ecomm_daily_sales?site_id=" +
          this.inputSite +
          "&sales_channel_id=" +
          this.inputSalesChannel +
          "&report_document=" +
          this.inputReportDoc +
          "&date_from=" +
          from_date +
          "&date_to=" +
          to_date +
          "&group=" +
          this.inputGroupBy +
          "&isShow=" +
          this.isShowDetail +
          "&isSeparate=" +
          this.isSeparateSite +
          "&order=" +
          this.inputSortBy +
          "&by=" +
          this.showSortInfo +
          "&top=" +
          this.inputShowTop +
          additional_params,
        null
      );
      if (get_request.error) {
        reportUtils.openNotificationWithIcon(component_x, "error", get_request.error);
        return;
      }
      var siteSpecific = get_request;
      if (get_request.length > 0) {
        let headers = [];
        let site_specific = [];
        if (this.isShowDetail == true) {
          headers = [
            "#",
            "Barcode",
            "Description",
            "Retail Price",
            "Qty",
            "Avg Price",
            "Landed Cost",
            "Avg Cost",
            "Total Amount",
          ];
        } else {
          headers = ["", "Qty", "Total Amount"];
        }

        for (let x = 0; x < siteSpecific.length; x++) {
          this.birSalesReports = siteSpecific[x].report_details;

          let total_qty = 0;
          let total_total_amount = 0;
          let grand_qty = 0;
          let grand_total_amount = 0;
          let reportData = [];
          let grouper = "start";
          let type_header = "start";
          if (this.birSalesReports.length > 0) {
            let monthly_grouper_arr = [];
            let arr = "start";

            if (this.inputGroupBy == "monthly" && this.isShowDetail == true) {
              for (let i = 0; i < this.birSalesReports.length; i++) {
                let reportLine = this.birSalesReports[i];

                if (i == this.birSalesReports.length - 1) {
                  if (arr == "start") {
                    monthly_grouper_arr.push({
                      key: reportLine.grouper_id,
                      value: reportLine.grouper_name,
                    });
                  } else {
                    if (arr.key == reportLine.grouper_id) {
                      //replace value then push
                      if (arr.value > reportLine.grouper_name) {
                        arr.value = reportLine.grouper_name;
                      }

                      monthly_grouper_arr.push(arr);
                    } else {
                      //push prev arr
                      monthly_grouper_arr.push(arr);

                      //push current arr
                      monthly_grouper_arr.push({
                        key: reportLine.grouper_id,
                        value: reportLine.grouper_name,
                      });
                    }
                  }
                } else {
                  if (arr == "start") {
                    arr = {
                      key: reportLine.grouper_id,
                      value: reportLine.grouper_name,
                    };
                  } else {
                    if (arr.key == reportLine.grouper_id) {
                      //replace value
                      if (arr.value > reportLine.grouper_name) {
                        arr.value = reportLine.grouper_name;
                      }
                    } else {
                      //push prev arr
                      monthly_grouper_arr.push(arr);

                      //replace current arr
                      arr = {
                        key: reportLine.grouper_id,
                        value: reportLine.grouper_name,
                      };
                    }
                  }
                }
              }
            }

            for (let i = 0; i < this.birSalesReports.length; i++) {
              let reportLine = this.birSalesReports[i];

              let grouper_name = reportLine.grouper_name;
              if (this.inputGroupBy == "daily") {
                grouper_name = moment(reportLine.grouper_name).format("YYYY/MM/DD");
              } else if (this.inputGroupBy == "monthly") {
                let vdate = monthly_grouper_arr.find(
                  (x) => x.key === reportLine.grouper_id
                ).value;
                grouper_name = moment(vdate).format("(YYYY) DD - MMMM");
              }

              if (this.inputGroupBy == "supplier_type_id") {
                if (type_header == "start") {
                  let type_header = [reportLine.header_name];
                  reportData.push(Object.assign({}, type_header));
                } else {
                  if (type_header != reportLine.header_id) {
                    let type_header = [reportLine.header_name];
                    reportData.push(Object.assign({}, type_header));
                  }
                }
                type_header = reportLine.header_id;
              }

              if (this.inputGroupBy != "") {
                if (this.isShowDetail == true) {
                  if (grouper == "start") {
                    let detail_header = [grouper_name];
                    reportData.push(Object.assign({}, detail_header));
                  } else {
                    if (grouper != reportLine.grouper_id) {
                      let detail_header = [grouper_name];
                      reportData.push(Object.assign({}, detail_header));
                    }
                  }
                  grouper = reportLine.grouper_id;
                }
              }

              let detail = [];
              if (this.isShowDetail == true) {
                detail = [
                  i + 1,
                  reportLine.barcode,
                  reportLine.description,
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.retail_price)), 'Y'),
                  this.convertToCurrency(Number(reportLine.qty)),
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_price)), 'Y'),
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.landed_cost)), 'Z'),
                  this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_cost)), 'Z'),
                  this.convertToCurrency(Number(reportLine.total_amount)),
                ];
              } else {
                detail = [
                  grouper_name,
                  this.convertToCurrency(Number(reportLine.qty)),
                  this.convertToCurrency(Number(reportLine.total_amount)),
                ];
              }
              reportData.push(Object.assign({}, detail));

              total_qty += Number(reportLine.qty);
              total_total_amount += Number(reportLine.total_amount);

              grand_qty += Number(reportLine.qty);
              grand_total_amount += Number(reportLine.total_amount);

              if (i == this.birSalesReports.length - 1) {
                if (this.inputGroupBy != "") {
                  let sub_detail = [];
                  if (this.isShowDetail == true) {
                    let spacer = grouper_name;
                    if (this.inputGroupBy == "supplier_type_id") {
                      spacer = reportLine.header_name;
                    }

                    let group_text = "";
                    if (this.inputGroupBy != "") {
                      group_text =
                        " by " +
                        this.groupOptions.find((x) => x.key === this.inputGroupBy).value;
                    }

                    let printed_by = secureStorage.getItem("email");
                    if (printed_by == null) {
                      printed_by = "";
                    }

                    sub_detail = [
                      "Daily Sales Report" + group_text,
                      "Generate By: " + printed_by,
                      "For the Period of " + from_header + " to " + to_header,
                      spacer,
                      this.convertToCurrency(total_qty),
                      "",
                      "",
                      "",
                      this.convertToCurrency(total_total_amount),
                    ];
                    reportData.push(Object.assign({}, sub_detail));
                  }
                }

                if (this.isShowDetail == true) {
                  let group_text = "";
                  if (this.inputGroupBy != "") {
                    group_text =
                      " by " +
                      this.groupOptions.find((x) => x.key === this.inputGroupBy).value;
                  }

                  let printed_by = secureStorage.getItem("email");
                  if (printed_by == null) {
                    printed_by = "";
                  }
                  reportData.push(
                    Object.assign({}, [
                      "Daily Sales Report" + group_text,
                      "Generate By: " + printed_by,
                      "For the Period of " + from_header + " to " + to_header,
                      "Grand Total :",
                      this.convertToCurrency(grand_qty),
                      "",
                      "",
                      "",
                      this.convertToCurrency(grand_total_amount),
                    ])
                  );
                } else {
                  reportData.push(
                    Object.assign({}, [
                      "Grand Total :",
                      this.convertToCurrency(grand_qty),'','',
                      this.convertToCurrency(grand_total_amount),
                    ])
                  );
                }
              } else {
                if (this.isShowDetail == true) {
                  let current_grouper = "";
                  let next_grouper = "";
                  if (this.inputGroupBy == "supplier_type_id") {
                    current_grouper = reportLine.header_id;
                    next_grouper = this.birSalesReports[i + 1].header_id;
                  } else {
                    current_grouper = reportLine.grouper_id;
                    next_grouper = this.birSalesReports[i + 1].grouper_id;
                  }

                  if (current_grouper != next_grouper) {
                    if (this.inputGroupBy != "") {
                      let sub_detail = [];

                      let group_text = "";
                      if (this.inputGroupBy != "") {
                        group_text =
                          " by " +
                          this.groupOptions.find((x) => x.key === this.inputGroupBy)
                            .value;
                      }

                      let printed_by = secureStorage.getItem("email");
                      if (printed_by == null) {
                        printed_by = "";
                      }

                      let spacer = grouper_name;
                      if (this.inputGroupBy == "supplier_type_id") {
                        spacer = reportLine.header_name;
                      }

                      if (this.isShowDetail == true) {
                        sub_detail = [
                          "Daily Sales Report" + group_text,
                          "Generate By: " + printed_by,
                          "For the Period of " + from_header + " to " + to_header,
                          spacer,
                          this.convertToCurrency(total_qty),
                          "",
                          "",
                          "",
                          this.convertToCurrency(total_total_amount),
                        ];
                      } else {
                        sub_detail = [
                          spacer,
                          this.convertToCurrency(total_qty),
                          this.convertToCurrency(total_total_amount),
                        ];
                      }
                      reportData.push(Object.assign({}, sub_detail));

                      total_qty = 0;
                      total_total_amount = 0;
                    }
                  }
                }
              }
            }
          }

          let keys = headers;
          let values = reportData;
          var values_length = values.length;

          let newJsonData = [];

          // change headers and report data as key and value object
          for (var i = 0; i < values_length; i++) {
            var result = Object.assign.apply(
              {},
              keys.map((val, index) => ({
                [val]: values[i][index],
              }))
            );
            newJsonData.push(result);
          }

          // change undefined on arr
          newJsonData.forEach(function (obj) {
            for (var i in obj) {
              if (obj[i] === undefined || obj[i] === null) {
                obj[i] = "";
              }
            }
          });
          site_specific.push(newJsonData);
          // this.JsonData = site_specific;
        }

        this.JsonData = site_specific.flat(Infinity);
      } else {
        reportUtils.openNotificationWithIcon(component_x, "error", "No Data.");
      }
      this.spinning = false;
    },
    clearJsonData() {
      // console.log("working",this.JsonData)
      this.JsonData = [];
    },
    addMaskValidation(value, rights){
        if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
            return '***';
        }else{
            return value
        }
    }
  },
};
</script>

<style></style>
